const STOCK_STATUS = {
    LOW_STOCK: "LOW_STOCK",
    OUT_OF_STOCK: "OUT_OF_STOCK",
    IN_STOCK: "IN_STOCK",
}

export default STOCK_STATUS;